// Module
var code = `<div> <button class="btn btn-default btn-xs" translate>Balance Due</button> <button class="btn btn-success btn-xs" translate>Paid in Full</button> <button class="btn btn-danger btn-xs" translate>Overpaid</button> </div> `;
// Exports
var _module_exports =code;;
var path = '/features/eventRegistrations/registrationsPaidPopover.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;